export default "__VITE_ASSET__Qxq3qRkl__"